<template>
    <div class="qyfn" :style="{
        minHeight: `calc(100vh - ${topHeight || 0}px)`,
    }">
        <!-- Banner -->
        <div class='bannerImg'>
            <div class="bannercon">
                <div class="title">企业赋能服务</div>
                <div class="content">企业赋能新航向，贴心服务助梦远航</div>

            </div>
        </div>

        <div ref="qyfnRef" class="qyfn_content">
            <!-- 企业赋能服务介绍 -->
            <div class="qyfn_intro">
                <div class="qyfn_intro_left">
                    <div class="qyfn_intro_tag">企业赋能服务</div>
                    <div class="qyfn_intro_desc">
                        全球商通中心结合全球资讯、便捷服务和商城交易板块优势，联动产业联合体的院校与企业资源，强强联合搭建产教供需桥梁，为企业打造全方位协同发展平台。通过企业赋能服务，支持 VR 探场展示企业风貌、详述企业信息增强信任、全面呈现商品拓宽销路。同时，发挥联合体聚合效应，整合上下游资源，促进企业优势互补、资源共享；打通产教供需通道，精准对接院校人才、技术与企业需求，破解人才、技术难题。全方位助力企业抓商机、提品牌、强竞争，推动企业、产业、院校协同共进。
                    </div>
                </div>
                <div class="qyfn_intro_right">
                    <div class="qyfn_intro_right_card">
                        <div class="qyfn_intro_right_title">企业入驻服务</div>
                        <div class="qyfn_intro_right_btn" @click="handleApply">点击咨询</div>
                    </div>
                </div>
            </div>

            <!-- 四大功能模块 -->
            <div class="qyfn_features">
                <div class="qyfn_features_item" v-for="(item, index) in featureList" :key="index">
                    <div class="qyfn_features_icon">
                        <img :src="item.icon" :alt="item.name" />
                    </div>
                    <div class="qyfn_features_name">{{ item.name }}</div>
                    <div class="qyfn_features_desc">{{ item.desc }}</div>
                </div>
            </div>

        </div>

        <!-- 赋能企业服务列表（全宽白色背景区块） -->
        <div class="qyfn_list_section">
            <div class="qyfn_list_inner">
                <div class="qyfn_list_title">赋能企业服务列表</div>

                <div class="qyfn_list" v-loading="listLoading">
                    <div class="qyfn_list_item" v-for="(item, index) in enterpriseList" :key="index"
                        @click="handleItemClick(item)">

                        <div class="qyfn_list_item_img" v-if="item.qytp">
                            <img  :src="commenUrl + item.qytp.split(',')[0]" alt="" />
                           
                        </div>

                        <div class="qyfn_list_item_img" v-else style = 'background: #E1EAF9 ;display: flex; justify-content: space-around; align-items: center;'>
                           
                            <img style= 'width:88px;height:88px' src="../../assets/images/xszgDetail/qytp.png" alt="" />
                        </div>
                      

                        <div class="qyfn_list_item_info">
                            <div class="qyfn_list_item_name">{{ item.qymc }}</div>
                            <div class="qyfn_list_item_desc">{{ item.qyjj }}</div>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="qyfn_pagination">
                    <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                        v-model:current-page="currentPage" @current-change="handlePageChange" />
                </div>
            </div>
        </div>

        <!-- 底部咨询栏 -->
        <div class="qyfn_footer_bar">
            <div class="qyfn_footer_bar_content">
                <span class="qyfn_footer_bar_label">如果您有：</span>
                <div class="qyfn_footer_bar_tags">
                    <span class="qyfn_footer_bar_tag" v-for="(tag, i) in footerTags" :key="i"
                        @click="handleTagClick(tag)">{{ tag }}</span>
                </div>
                <div class="qyfn_footer_bar_btn" @click="handleApply">点击咨询</div>
            </div>
        </div>

        <!-- 企业详情弹框 -->
        <div class="diaBox">
            <el-dialog v-model="dialogVisible" title="企业详情" width="1200" append-to-body top="50px">
                <div class="diaCon">
                    <div class="diaConLsft">
                        <div class="carBox">
                            <iframe v-if="djobj.flag == 1" style="width:100%;height:100%" :src="djobj.url"
                                frameborder="0"></iframe>
                            <img style="width:100%;height:100%" v-if="djobj.url && djobj.flag != 1"
                                :src="commenUrl + djobj.url" alt="">
                        </div>
                        <div class="chooseList">
                            <el-carousel :interval="5000" :arrow="hover" height="100px" indicator-position="none">
                                <el-carousel-item v-for="(item, index) in urls" :key="index">
                                    <div class="xhList">
                                        <div class="xhItem" v-for="(i, v) in item" :key="v" @click="handleclickitem(i)">
                                            <div class="xhItemBoder" v-if="i.flag == 1">
                                                <img src="../../assets/images/xszgDetail/vrbj.png" alt="">
                                            </div>
                                            <img v-else :src="commenUrl + i.url" alt="">
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                    <div class="diaConright" >
                        <div class = 'gowzshopBox' v-if = 'result.qywz'>
                            <div></div>
                            <div class="gowzshop"  @click="handleclickgowz(result.qywz)">前往公司网站></div>
                        </div>
                       
                        <div class="goscshop" v-if="result.qysc" @click="handleclickgowz(result.qysc)">去商城 ></div>
                        <div class="rightTitle">{{ result.qymc }}</div>
                        <div class="rightBq" v-if = 'result.qybq '>{{ result.qybq }}</div>
                        <div class="rightConWrite">{{ result.qyjs }}</div>
                        <div class="scsp" v-if="spList.length > 0">企业商品</div>
                        <div class="spList">
                            <div class="spItem" v-for="(item, index) in spList" :key="index"
                                @click="handleclickspDetail(item.splj)">
                                <img v-if="item.sptp" :src="commenUrl + item.sptp" alt="">
                                <img v-else src="../../assets/images/newsDefault.png" alt="">
                                <div>
                                    <p class="title">{{ item.spmc }}</p>
                                    <p class="sysl">{{ item.spkc }}</p>
                                    <p class="price" v-if="item.spjg">{{ item.spjg }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
        
    </div>
</template>

<script>
import {
    getCurrentInstance,
    ref,
    onMounted,
    nextTick,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import banner from '@/components/banner.vue';

export default {
    name: 'qyfn',
    props: {
        themeColor: {
            type: String,
            default: 'blue',
        },
        topHeight: {
            type: Number,
            default: 0,
        },
    },
    components: {
        banner,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();

        const qyfnRef = ref(null);

        // 四大功能模块数据
        const featureList = ref([
            {
                icon: require('@/assets/images/qyfn1.png'),
                name: 'VR探场',
                desc: '沉浸式体验，身临其境感受企业实力。',
            },
            {
                icon: require('@/assets/images/qyfn2.png'),
                name: '详情展示',
                desc: '全面呈现企业信息，增强客户信任度。',
            },
            {
                icon: require('@/assets/images/qyfn3.png'),
                name: '商品呈现',
                desc: '全方位展示商品，拓宽线上销售渠道。',
            },
            {
                icon: require('@/assets/images/qyfn4.png'),
                name: '商机抢抓',
                desc: '快速对接，深度服务，把握市场先机。',
            },
        ]);

        // 底部标签
        const footerTags = ref([
            '企业VR拍摄',
            '企业人才定制',
            '技术协同创新',
            '市场与品牌增值',
            '企业技术培训',
            '企业出海贸易',
            '......'
        ]);

        // 列表数据
        const enterpriseList = ref([ ]);
        const listLoading = ref(false);
        const total = ref(0);
        const pageSize = ref(8);
        const currentPage = ref(1);



        // ---- 弹框相关变量 ----
        const dialogVisible = ref(false);
        const djobj = ref({});
        const result = ref({});
        const spList = ref([]);
        const urls = ref([]);

        // 轮播图数组转换
        const groupArray = (arr, size) => {
            const res = [];
            for (let i = 0; i < arr.length; i += size) {
                res.push(arr.slice(i, i + size));
            }
            return res;
        };

        // 点击企业列表项，打开详情弹框
        const handleclickqyDetail = (id) => {
            djobj.value = {};
            urls.value = [];
            spList.value = [];
            dialogVisible.value = true;
            proxy.$request({
                method: 'post',
                url: 'QPSTZX_SXYZG_ZGQYSPLIST',
                data: { id: id },
            }).then((res) => {
                if (res.data.code == '000') {
                    result.value = res.data.result;
                    if (res.data.result.urls && res.data.result.urls.length > 0) {
                        djobj.value = res.data.result.urls[0];
                        urls.value = groupArray(res.data.result.urls, 5);
                    }
                    spList.value = (res.data.result.spList || []).slice(0, 4);
                    // 补充商品图片和信息
                    spList.value.map((item) => {
                        if (item.splj) {
                            proxy.$request({
                                method: 'post',
                                url: 'SHOPHOME_FINDESPRODUCTINFO',
                                data: { id: item.splj.split('=')[1] },
                            }).then((res2) => {
                                if (res2.data.code == '000') {
                                    const r = res2.data.result;
                                    item.sptp = r.productImgs ? r.productImgs.split(',')[0] : '';
                                    item.spmc = r.productName || '';
                                    let unit = '';
                                    try {
                                        JSON.parse(r.keyAttributes || '[]').map((attr) => {
                                            if (attr.label == '计量单位') unit = attr.value;
                                        });
                                    } catch (e) { }
                                    if (r.inventoryModel == '1' && r.productSpecs[0]?.dayOutput) {
                                        item.spkc = r.productSpecs[0].dayOutput + unit;
                                    } else if (r.inventoryModel == '0' && r.productSpecs[0]?.stock) {
                                        item.spkc = r.productSpecs[0].stock + unit;
                                    }
                                    if (r.productSpecs[0]?.salesPriceType == '1') {
                                        item.spjg = '面议';
                                    } else if (r.productSpecs[0]?.price) {
                                        item.spjg = r.productSpecs[0].price.toFixed(2) + '元/' + unit;
                                    }
                                }
                            });
                        }
                    });
                }
            });
        };

        // 点击缩略图切换主图
        const handleclickitem = (obj) => {
            djobj.value = obj;
        };

        // 前往公司网站/商城
        const handleclickgowz = (wzPath) => {
            if (wzPath) window.open(wzPath);
        };

        // 点击商品跳转详情
        const handleclickspDetail = (url) => {
            if (url) window.open(url);
        };
        
        // el-carousel arrow 参数
        const hover = 'hover';

        const getEnterpriseList = () => {
              listLoading.value = true;
              proxy
                .$request({
                  url: 'QPSTZX_SXYZG_ZGQYLIST',
                  method: 'post',
                  data: {
                    pageInfo:{
                        pageNo: currentPage.value,
                        pageSize: pageSize.value,
                    },
                   
                    "type":"1"
                  },
                })
                .then((res) => {
                  if (res.data.code === '000') {
                    enterpriseList.value = res.data.result.list || res.data.result || [];
                    total.value = res.data.result.count || 0;
                  }
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => {
                  listLoading.value = false;
                });
        };

        const handlePageChange = (page) => {
            currentPage.value = page;
            getEnterpriseList();
        };

        const handleItemClick = (item) => {
            // 打开企业详情弹框，传 id
            handleclickqyDetail(item._id || item.id);
        };

        const handleApply = () => {
            window.open('https://mall.nfstzx.com/industry/dataAcquisitionForm?id=1210434388605200272')
            // 点击咨询逻辑，可根据实际需求修改
            // proxy.$message && proxy.$message({ message: '请联系客服进行咨询', type: 'info' });
        };

        const handleTagClick = (tag) => {
            // 点击底部标签
        };

        onMounted( () => {
            getEnterpriseList();
        });

        return {
            qyfnRef,
            featureList,
            footerTags,
            enterpriseList,
            listLoading,
            total,
            pageSize,
            currentPage,
            handlePageChange,
            handleItemClick,
            handleApply,
            handleTagClick,
            // 弹框相关
            dialogVisible,
            djobj,
            result,
            spList,
            urls,
            handleclickqyDetail,
            handleclickitem,
            handleclickgowz,
            handleclickspDetail,
            hover,
        };
    },
};
</script>

<style lang="less" scoped>
.qyfn {
    width: 100%;
    background: #f7f7f7;
    box-sizing: border-box;
    padding-bottom: 0;

    .bannerImg {
        width: 100%;
        height: 400px;
        background: url('../../assets/images/qyfnbanner.png');
        background-size: 100% 100%;

        .bannercon {
            width: 1200px;
            height: 400px;
            margin: 0 auto;
            padding-top: 140px;
            box-sizing: border-box;

            .title {
                width: 100%;
                text-align: center;
                height: 65px;
                font-family: AlibabaPuHuiTi_2_85_Bold;
                font-size: 46px;
                color: #FFFFFF;
                line-height: 65px;

            }

            .content {
                width: 100%;
                text-align: center;
                height: 33px;
                font-family: AlibabaPuHuiTi_2_55_Regular;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 33px;
                margin-top: 20px;

            }
        }
    }

    .qyfn_content {
        width: 1200px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-bottom: 40px;

        // ---- 介绍区域 ----
        .qyfn_intro {
            display: flex;
            align-items: stretch;
            margin-top: 40px;
            gap: 30px;

            .qyfn_intro_left {
                flex: 1;
                background: #fff;
                padding: 30px 40px;
                box-sizing: border-box;

                .qyfn_intro_tag {
                    font-weight: 600;
                    font-size: 18px;
                    color: #313a4b;
                    margin-bottom: 20px;
                }

                .qyfn_intro_desc {
                    font-size: 14px;
                    color: #57647c;
                    line-height: 28px;
                }
            }

            .qyfn_intro_right {
                width: 240px;
                flex-shrink: 0;

                .qyfn_intro_right_card {
                    width: 100%;
                    height: 100%;
                    min-height: 160px;
                    //   background: linear-gradient(135deg, #1a6fe8 0%, #0754bd 100%);
                    background: url('../../assets/images/qyrzfw.png') no-repeat;
                    background-size: 100% 100%;

                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 20px;
                    padding: 20px;
                    box-sizing: border-box;

                    .qyfn_intro_right_title {
                        font-weight: 600;
                        font-size: 20px;
                        color: #ffffff;
                        text-align: center;
                    }

                    .qyfn_intro_right_btn {
                        width: 100px;
                        height: 36px;
                        background: rgba(255, 255, 255, 0.2);
                        border: 1px solid #ffffff;
                        border-radius: 18px;
                        font-size: 14px;
                        color: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        transition: background 0.2s;

                        &:hover {
                            background: rgba(255, 255, 255, 0.35);
                        }
                    }
                }
            }
        }

        // ---- 四大功能模块 ----
        .qyfn_features {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
            margin-top: 40px;

            .qyfn_features_item {
                padding: 28px 20px 24px;
                background: #fff;
                box-sizing: border-box;
                border-radius: 8px;
                cursor: default;
                transition: box-shadow 0.2s;
                border-radius: 20px;

                &:hover {
                    box-shadow: 0px 4px 16px 0px rgba(7, 84, 189, 0.12);
                }

                .qyfn_features_icon {
                    width: 48px;
                    height: 48px;
                    margin-bottom: 14px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .qyfn_features_name {
                    font-weight: 600;
                    font-size: 16px;
                    color: #313a4b;
                    margin-bottom: 10px;
                }

                .qyfn_features_desc {
                    font-size: 13px;
                    color: #57647c;
                    line-height: 22px;
                }
            }
        }

        // ---- 列表标题 ----
        .qyfn_list_title {
            text-align: center;
            font-weight: 600;
            font-size: 30px;
            color: #313a4b;
            margin-top: 60px;
            margin-bottom: 30px;
            line-height: 42px;
        }

        // ---- 企业列表 ----
        .qyfn_list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;

            .qyfn_list_item {
                height: 415px;
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;
                transition: box-shadow 0.2s, transform 0.2s;
                box-sizing: border-box;

                &:hover {
                    box-shadow: 0px 4px 16px 0px rgba(7, 84, 189, 0.15);
                    transform: translateY(-2px);
                }

                .qyfn_list_item_img {
                    width: 100%;
                    height: 223px;
                    overflow: hidden;
                    border-radius: 8px 8px 0 0;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: transform 0.3s;
                    }

                    &:hover img {
                        transform: scale(1.04);
                    }
                }

                .qyfn_list_item_info {
                    height: 192px;
                    padding: 14px 16px 18px;
                    box-sizing: border-box;

                    .qyfn_list_item_name {
                        font-weight: 600;
                        font-size: 20px;
                        color: #313a4b;
                        margin: 20px 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .qyfn_list_item_desc {
                        font-size: 16px;
                        color: #57647c;
                        line-height: 28px;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }
                }
            }
        }

        // ---- 分页 ----
        .qyfn_pagination {
            display: flex;
            justify-content: center;
            margin-top: 40px;

            :deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
                background-color: #0754bd;
            }
        }
    }

    // ---- 列表全宽白色背景区块 ----
    .qyfn_list_section {
        width: 100%;
        background: #fff;
        padding: 20px 0 20px;
        box-sizing: border-box;

        .qyfn_list_inner {
            width: 1200px;
            margin: 0 auto;
            box-sizing: border-box;

            // ---- 列表标题 ----
            .qyfn_list_title {
                text-align: center;
                font-weight: 600;
                font-size: 30px;
                color: #313a4b;
                padding-top: 40px;
                margin-bottom: 30px;
                line-height: 42px;
            }

            // ---- 企业列表 ----
            .qyfn_list {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 20px;

                .qyfn_list_item {
                    height: 415px;
                    border-radius: 8px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: box-shadow 0.2s, transform 0.2s;
                    box-sizing: border-box;
                    background: #fff;

                    &:hover {
                        box-shadow: 0px 4px 16px 0px rgba(7, 84, 189, 0.15);
                        transform: translateY(-2px);
                    }

                    .qyfn_list_item_img {
                        width: 100%;
                        height: 223px;
                        overflow: hidden;
                        border-radius: 8px 8px 0 0;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transition: transform 0.3s;
                        }

                        &:hover img {
                            transform: scale(1.04);
                        }
                    }

                    .qyfn_list_item_info {
                        height: 192px;
                        padding: 14px 16px 18px;
                        box-sizing: border-box;

                        .qyfn_list_item_name {
                            font-weight: 600;
                            font-size: 20px;
                            color: #313a4b;
                            margin: 20px 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .qyfn_list_item_desc {
                            font-size: 16px;
                            color: #57647c;
                            line-height: 28px;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                    }
                }
            }

            // ---- 分页 ----
            .qyfn_pagination {
                display: flex;
                justify-content: center;
                margin-top: 40px;

                :deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
                    background-color: #0754bd;
                }
            }
        }
    }

    // ---- 底部咨询栏 ----
    .qyfn_footer_bar {
        width: 100%;

        padding: 18px 0;
        box-sizing: border-box;

        .qyfn_footer_bar_content {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            height: 100px;
            box-sizing: border-box;
            background: #0754bd;
            border-radius: 10px;
            padding: 0 20px;

            .qyfn_footer_bar_label {
                font-size: 14px;
                color: #ffffff;
                white-space: nowrap;
            }

            .qyfn_footer_bar_tags {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                flex: 1;

                .qyfn_footer_bar_tag {
                    height: 36px;
                    width: 122px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    border: 1px solid rgba(255, 255, 255, 0.5);
                    border-radius: 16px;
                    font-size: 13px;
                    color: #ffffff;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: background 0.2s, border-color 0.2s;

                    &:hover {
                        background: rgba(255, 255, 255, 0.15);
                        border-color: #ffffff;
                    }
                }
            }

            .qyfn_footer_bar_more {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.7);
            }

            .qyfn_footer_bar_btn {
                width: 110px;
                height: 36px;
                background: #ffffff;
                border-radius: 18px;
                font-size: 14px;
                font-weight: 600;
                color: #0754bd;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                white-space: nowrap;
                transition: opacity 0.2s;
                flex-shrink: 0;
                cursor: pointer;

                &:hover {
                    opacity: 0.9;
                }
            }
        }
    }
}

// ---- 1680px 宽屏适配 ----
@media (min-width: 1680px) {
    .qyfn {
        .qyfn_content {
            width: 1600px;
        }

        .qyfn_list_section {
            .qyfn_list_inner {
                width: 1600px;
            }
        }

        .qyfn_footer_bar {
            .qyfn_footer_bar_content {
                width: 1600px;

                .qyfn_footer_bar_tags {
                    .qyfn_footer_bar_tag {
                        width: 180px;
                    }
                }
            }
        }
    }
}

// ---- 移动端适配 ----
@media (max-width: 768px) {
    .qyfn {
        .qyfn_content {
            width: 100%;
            padding: 0 16px 50px;
            box-sizing: border-box;

            .qyfn_intro {
                flex-direction: column;
                margin-top: 24px;
                gap: 16px;

                .qyfn_intro_left {
                    padding: 20px 16px;
                }

                .qyfn_intro_right {
                    width: 100%;

                    .qyfn_intro_right_card {
                        min-height: 120px;
                        flex-direction: row;
                        justify-content: space-between;
                        padding: 16px 20px;
                    }
                }
            }

            .qyfn_features {
                grid-template-columns: repeat(2, 1fr);
                gap: 12px;
                margin-top: 24px;
            }

            .qyfn_list_title {
                font-size: 22px;
                margin-top: 40px;
                margin-bottom: 20px;
            }

            .qyfn_list {
                grid-template-columns: repeat(2, 1fr);
                gap: 12px;

                .qyfn_list_item {
                    .qyfn_list_item_img {
                        height: 120px;
                        border-radius: 8px 8px 0 0;
                    }
                }
            }

            .qyfn_pagination {
                margin-top: 24px;
            }
        }

        .qyfn_list_section {
            padding: 0 0 40px;

            .qyfn_list_inner {
                width: 100%;
                padding: 0 16px;
                box-sizing: border-box;

                .qyfn_list_title {
                    font-size: 22px;
                    padding-top: 30px;
                    margin-bottom: 20px;
                }

                .qyfn_list {
                    grid-template-columns: repeat(2, 1fr);
                    gap: 12px;

                    .qyfn_list_item {
                        .qyfn_list_item_img {
                            height: 120px;
                            border-radius: 8px 8px 0 0;
                        }
                    }
                }

                .qyfn_pagination {
                    margin-top: 24px;
                }
            }
        }

        .qyfn_footer_bar {
            .qyfn_footer_bar_content {
                width: 100%;
                padding: 0 16px;
                gap: 8px;

                .qyfn_footer_bar_tags {
                    .qyfn_footer_bar_tag {
                        height: 36px;
                        width: 152px;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        border: 1px solid rgba(255, 255, 255, 0.5);
                        border-radius: 16px;
                        font-size: 14px;
                        color: #ffffff;
                        cursor: pointer;
                        white-space: nowrap;
                        transition: background 0.2s, border-color 0.2s;

                    }
                }

                .qyfn_footer_bar_btn {
                    width: 90px;
                    height: 34px;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>

<!-- 弹框样式（无 scoped，el-dialog 挂载到 body） -->
<style lang="less">
.el-dialog {
    height: 825px !important;
    margin-top: 30px !important;
}

.el-dialog__header {
    border-bottom: 1px solid #DDE6F1;
    height: 36px;

    .el-dialog__title {
        color: #313A4B;
        font-weight: 900;
    }
}

.diaCon {
    width: 100%;
    height: 760px;
    display: flex;
    padding-top: 20px;
    justify-content: space-between;

    .diaConLsft {
        width: 600px;
        height: 720px;

        .carBox {
            height: 600px;
            background: #E1EAF9;
        }

        .chooseList {
            width: 100%;
            height: 100px;
            margin-top: 20px;

            .xhList {
                display: flex;

                .xhItem {
                    width: 100px;
                    height: 100px;
                    background: #E1EAF9;
                    border-radius: 4px;
                    margin-right: 20px;
                    cursor: pointer;

                    .xhItemBoder {
                        width: 96px;
                        height: 98px;
                        background: #E1EAF9;
                        border-radius: 4px;
                        margin-right: 20px;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;

                        img {
                            width: 56px;
                            height: 43px;
                            display: block;
                            border-radius: 4px;
                        }
                    }

                    img {
                        width: 98px;
                        height: 98px;
                        display: block;
                        border-radius: 4px;
                    }
                }
            }
        }
    }

    .diaConright {
        width: 535px;
        height: 735px;
        position: relative;
        display: flex;
        flex-direction: column;
        .gowzshopBox{
            display: flex;
            justify-content: space-between;

            .gowzshop {
            width: 143px;
            height: 56px;
            background: #DFEAFF;
            border-radius: 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #1663FF;
            line-height: 22px;
            text-align: left;
            display: flex;
            justify-content: space-around;
            align-items: center;
            cursor: pointer;
        }
        }

       

        .goscshop {
            width: 90px;
            height: 28px;
            background: #DFEAFF;
            border-radius: 17px 17px 0px 0px;
            padding: 0 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 14px;
            color: #1663FF;
            line-height: 20px;
            display: flex;
            align-items: center;
            position: absolute;
            bottom: -15px;
            left: 200px;
            cursor: pointer;
        }

        .rightTitle {
            // height: 33px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #313A4B;
            line-height: 33px;
            text-align: left;
            
        }

        .rightBq {
            height: 22px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #1663FF;
            line-height: 22px;
            text-align: left;
            margin-top: 5px;
        }

        .rightConWrite {
            margin-top: 24px;
            width: 535px;
            // height: 360px;
            flex:1;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #748199;
            line-height: 24px;
            text-align: left;
            overflow: auto;
        }

        .scsp {
            margin: 25px 0 13px;
            width: 130px;
            height: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 20px;
            color: #313A4B;
            line-height: 28px;
            text-align: left;
        }

        .spList {
            width: 100%;
            height: 200px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .spItem {
                width: 256px;
                height: 82px;
                display: flex;
                cursor: pointer;

                img {
                    width: 82px;
                    height: 82px;
                    background: #E1EAF9;
                    border-radius: 4px;
                    margin-right: 12px;
                }

                .title {
                    width: 162px;
                    height: 22px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #313A4B;
                    line-height: 22px;
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .sysl {
                    width: 162px;
                    height: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #313A4B;
                    line-height: 20px;
                    text-align: left;
                    margin: 3px 0 15px 0;
                }

                .price {
                    width: 100%;
                    height: 20px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    text-align: left;
                    color: #F53F3F;
                }
            }
        }
    }
}
</style>
